// WCA input rows (editable in the table)
  export const defaultWcaRows = [ 
  { ft: "ATL", cruiseAlt: "3000", cas: "103", tc: "182",  },
  { ft: "ATL", cruiseAlt: "7000", cas: "130", tc: "182",  },

];

export const defaultForecastTerminals = [
{
    ft: "ATL",
    alt1: "3000",
    alt2: "6000",
    alt3: "9000",
    wd1: "250",
    wd2: "260",
    wd3: "270",
    ws1: "",
    ws2: "",
    ws3: "",
    t1: "",
    t2: "",
    t3: "",
  },
  {
    ft: "PIE",
    alt1: "3000",
    alt2: "6000",
    alt3: "9000",
    wd1: "240",
    wd2: "250",
    wd3: "260",
    ws1: "",
    ws2: "",
    ws3: "",
    t1: "",
    t2: "",
    t3: "",
  },
];

// Region Stations
/** 
export const regionStations = {
  mia: ["ATL", "PIE", "MIA", "JAX", "MLB", "EYW", "TLH", "PFN", "CSG", "SAV", "HAT", "ILM", "RDU", "CAE", "CHS", "FLO", "GSP", "2XG"],
  bos: ["BOS"],
  chi: ["ORD", "MDW"],
  dfw: ["DFW"],
  slc: ["SLC", "DEN", "COS", "GJT", "ASE", "EGE", "RNO", "BOI", "SUN", "TUS", "PHX", "PRC", "TUS", "ALS", "PUB", "LWS", "PIH","DLN", "GGW", "GPI", "BIL", "GTF", "MLS", "BAM", "ELY", "LAS", "RNO", "ABQ", "FMN", "ROW", "TCC", "ZUN", "BCE", "CZI", "LND", "MBW", "RKS"],
  sfo: ["SFO", "PDX", "BIH", "BLH", "FAT", "FOT", "ONT", "RBL", "SAC", "SAN", "SBA", "SIY", "WJF", "AST", "IMB", "LKV"],
  
};
*/